<section>
	@if (currentSubState === TreatmentSelectionSubstate.PRODUCT_SELECTION ){
		<tm2-anamnese-product-selection
			[isUserProfessionalCertified]="isUserProfessionalCertified"
			[isUserOrcadentCertified]="isUserOrcadentCertified"
			(next)="onNext($event)"
		></tm2-anamnese-product-selection>
	}

	@if (currentSubState === TreatmentSelectionSubstate.OPTIONS ){
		<tm2-anamnese-options
		[anamnese]="anamnese"
		[isProfessionalSubsequentOrder]="isProfessionalSubsequentOrder"
		(next)="onNext($event)"
		></tm2-anamnese-options>
	}

	@if (currentSubState === TreatmentSelectionSubstate.QUESTIONNAIRE && !isOrcadentProduct){
		<tm2-anamnese-questionaire
		[anamnese]="anamnese"
		[level]="questionnaireScopeLevel"
		(next)="onNext($event)"
		></tm2-anamnese-questionaire>
	}
	@else if (currentSubState === TreatmentSelectionSubstate.QUESTIONNAIRE && isOrcadentProduct){
		<tm2-anamnese-questionnaire-orcadent
			(next)="onNext($event)"
		></tm2-anamnese-questionnaire-orcadent>
	}

</section>
